<ui-panel class="additional-device-banner text--center">
  <ui-panel-body>
    <div class="p-6">
      <div class="additional-device-banner__text typog-h4">
        Add up to {{ numberOfDevices }} additional devices for £
        {{ price | number: '1.2-2' }} a month each
      </div>
    </div>
  </ui-panel-body>
</ui-panel>
